import { render, staticRenderFns } from "./expand-list.vue?vue&type=template&id=0c3d8b09&"
import script from "./expand-list.vue?vue&type=script&lang=js&"
export * from "./expand-list.vue?vue&type=script&lang=js&"
import style0 from "./expand-list.vue?vue&type=style&index=0&id=0c3d8b09&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports